export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8521.d2092190.jpg";